/**
 * @typedef {Object} DayDetails
 * @property {number} date
 * @property {number} month
 * @property {string} dayString
 * @property {(*|null)} reminder
 * @property {number} day
 * @property {number} timestamp
 * /

 /**
 * @param args
 * @returns {DayDetails}
 */
const getDayDetails = (args) => {
  let date = args.index - args.firstDay;
  let day = args.index % 7;
  let prevMonth = args.month - 1;
  let prevYear = args.year;
  if (prevMonth < 0) {
    prevMonth = 11;
    prevYear--;
  }
  let prevMonthNumberOfDays = getNumberOfDays(prevYear, prevMonth);
  let _date = (date < 0 ? prevMonthNumberOfDays + date : date % args.numberOfDays) + 1;
  let valid = (date >= 0 && date < args.numberOfDays) ? 1 : 0;
  let timestamp = new Date(args.year, args.month, _date).getTime();
  return {
    date: _date,
    day,
    valid,
    timestamp,
    reminder: args.reminders[timestamp] || null
  };
};

/**
 * @param {number} year
 * @param {number} month
 * @param {number} reminders
 * @returns {DayDetails[]}
 */
export const getMonthDetails = (year, month, reminders) => {
  let firstDay = (new Date(year, month)).getDay();
  let numberOfDays = getNumberOfDays(year, month);
  let monthArray = [];
  let currentDay = null;
  let index = 0;
  let reminderMap = {};

  for (let idx in reminders) {
    let tempDate = new Date(reminders[idx].timestamp);
    let startOfTheDay = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate()).getTime();
    reminderMap[startOfTheDay] = reminders[idx];
  }

  for (let row = 0; row < 6; row++) {
    for (let col = 0; col < 7; col++) {
      currentDay = getDayDetails({
        index,
        numberOfDays,
        firstDay,
        year,
        month,
        reminders: reminderMap
      });
      monthArray.push(currentDay);
      index++;
    }
  }
  return monthArray;
};

export const getNumberOfDays = (year, month) => {
  return 32 - new Date(year, month, 32).getDate();
};